window.GUIDE = {

  id: 'authentic-paella-valenciana',

  title: 'Authentic Paella Valenciana',

  time: '90 min',

  servings: '4–6 guests',

  difficulty: 'Medium',

  settings: {
    autoplay: true,
    autoplayDelay: 10000,
    resumeDelay: 8000,
    loop: true,
    mobileBreakpoint: 900
  },

  attribution: {
    visible: true,
    text: 'Developed by IAIAO'
  },

  recipeGuide: {
    visible: true,
    eyebrow: 'Authentic Paella Valenciana',
    title: 'Step-by-Step Cooking Guide',
    intro: 'Keep the complete recipe close at hand while you cook.'
  },

  share: {
    visible: true,
    title: 'Share this Recipe',
    text: 'Enjoyed this recipe? Share it with friends and family.',
    whatsappLabel: 'WhatsApp',
    emailLabel: 'Email',
    copyLabel: 'Copy Link'
  },

  shop: {
  visible: true,

  collectionHandle:
    'paella-valenciana-ingredientes',

  eyebrow:
    'Spanish Kitchen',

  title:
    'Shop the Ingredients',

  text:
    'Everything you need to prepare an authentic Paella Valenciana at home.',

  groups: [

    {
      key: 'rice',
      value: 'skgc-rice',
      number: '01',

      title:
        'Rice',

      text:
        'Spanish round rice to absorb all the flavour and deliver it to you'
    },

    {
      key: 'olive-oil',
      value: 'skgc-olive-oil',
      number: '02',

      title:
        'Extra Virgin Olive Oil',

      text:
        'A mild Extra Virgin Olive Oil (EVOO) with a smooth finish works best for paella.'
    },

    {
      key: 'ingredients',
      value: 'skgc-ingredient',
      number: '03',

      title:
        'Essential Ingredients',

      text:
        ''
    },

    {
      key: 'seasonings',
      value: 'skgc-seasoning',
      number: '04',

      title:
        'Paella Seasonings',

      text:
        'Some ideas to boost the flavour'
    }

  ],

  viewAllLabel:
    'View Full Collection'
},

  slides: [

    /* =====================================================
       HERO
    ===================================================== */

    {
      type: 'hero',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/valencian_paella_hero_desktop.webp?v=1784622674',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/valencian_paella_hero_mobile.webp?v=1784622998',

        alt:
          'Paella Valenciana prepared outdoors on a Mediterranean terrace'
      },

      content: {
        eyebrow: 'Spanish Kitchen · Guided Cooking',
        title: 'Authentic Paella Valenciana',
        subtitle: 'A step-by-step guide'
      },

      timer: false
    },

    /* =====================================================
       STORY
    ===================================================== */

    {
      type: 'story',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/pople_together_desktop.webp?v=1786764753',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/peopble_together_mobile.webp?v=1786764752',

        alt:
          'People coming together around a Valencian paella'
      },

      content: {
        eyebrow: '',
        kicker: 'The story',
        title: 'Valencian paella',
        text: 'The art of sharing and bringing people together.',
        note: 'Let’s start with the ingredients'
      },

      timer: false
    },

    /* =====================================================
       INGREDIENTS
    ===================================================== */

    {
      type: 'ingredients',

      chapter: 'Ingredients',

      accordionExclude: true,

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/paella_valenciana_ingredinetes_desktop.webp?v=1784629375',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/paella_valenciana_ingredinetes_mobil.webp?v=1784625673',

        alt:
          'Traditional ingredients for Paella Valenciana'
      },

      content: {
        eyebrow: '',
        kicker: 'The ingredients',
        title: 'Bomba rice and...',
        text:
          'Chicken and/or rabbit, wide green beans, garrofó beans, grated tomato, saffron, sweet smoked paprika, garlic, salt, water, rosemary and extra virgin olive oil.'
      },

      timer: false
    },

    {
      type: 'ingredients',

      chapter: 'Ingredients',

      accordionImage: true,

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/ingredients_table_deskto.webp?v=1786703455',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/ingredinets_table_mobile.webp?v=1786703455',

        alt:
          'Paella Valenciana ingredient guide'
      },

      content: {
        eyebrow: '',
        kicker: 'Ingredients list',
        title: '',
        text: ''
      },

      timer: false
    },

    /* =====================================================
       BUILDING THE FLAVOUR
    ===================================================== */

    {
      type: 'step',

      chapter: 'Building the flavour',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/valencian_paella_heat_the_pan_and_oil_desktop.webp?v=1784630750',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/valencian_paella_heat_the_pan_and_oil_mobil.webp?v=1784631120',

        alt:
          'Heat the paella pan and olive oil'
      },

      content: {
        eyebrow: '',
        kicker: 'Let’s get started',
        title: 'Heat the pan',
        text: 'Over medium heat, pour the olive oil into the pan.',
        note: 'Allow it to heat for 2–3 minutes.'
      },

      timer: false
    },

    {
      type: 'step',

      chapter: 'Building the flavour',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/brown_the_meat_desktop.webp?v=1784645702',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/brow_th_emeat_mobile.webp?v=1784646793',

        alt:
          'Add salt and begin browning the meat'
      },

      content: {
        eyebrow: '',
        kicker: 'Building the flavour',
        title: 'Start with salt',
        text:
          'Sprinkle the salt in a circle around the edge of the pan to minimise splattering.',
        note: 'Start adding the meat.'
      },

      timer: false
    },

    {
      type: 'step',

      chapter: 'Building the flavour',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/brown_the_meat_desktop2.webp?v=1784651257',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/brown_th_e_meat_mobile2.webp?v=1784651293',

        alt:
          'Brown the chicken and rabbit'
      },

      content: {
        eyebrow: '',
        kicker: 'Building the flavour',
        title: 'Brown the meat',
        text:
          'Turn the meat every 5 minutes until well browned.',
        note:
          'Take your time. The caramelised bits that stick to the pan will add lots of flavour to the paella.'
      },

      timer: 'Approx. 20 min'
    },

    {
      type: 'step',

      chapter: 'Building the flavour',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/adding_wide_beans_desktop.webp?v=1784704912',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/addin_wide_beans_mobile.webp?v=1784704940',

        alt:
          'Add the wide green beans'
      },

      content: {
        eyebrow: '',
        kicker: 'Building the flavour',
        title: 'Add the green beans',
        text:
          'Push the meat away from the centre of the pan, then add the green beans.',
        note:
          'Cook for about 3 minutes.'
      },

      timer: '3–4 min'
    },

    {
      type: 'step',

      chapter: 'Building the flavour',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/adding_garlic_desktop.webp?v=1784706984',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/adding_garlic_mobile.webp?v=1784707007',

        alt:
          'Add the diced garlic'
      },

      content: {
        eyebrow: '',
        kicker: 'Building the flavour',
        title: 'Add the diced garlic',
        text:
          'Move the beans towards the edge and add the garlic.',
        note:
          'Sauté for about 30 seconds, making sure it does not burn.'
      },

      timer: '30 sec'
    },

    {
      type: 'step',

      chapter: 'Building the flavour',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/smoked_paprika_desktop.webp?v=1784727594',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/smoked_paprika_mobile.webp?v=1784730721',

        alt:
          'Add the butter beans and smoked paprika'
      },

      content: {
        eyebrow: '',
        kicker: 'Building the flavour',
        title: 'Add the butter beans & paprika',
        text:
          'Sauté for about 1–2 minutes. Stir gently to avoid breaking the beans.',
        note:
          'Push them away from the centre of the pan.'
      },

      timer: '2 min'
    },

    {
      type: 'step',

      chapter: 'Building the flavour',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/add_tomato_and_safrron_desktop.webp?v=1786761342',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/adding_tomato_and_sffron_mobile.webp?v=1786761342',

        alt:
          'Add the grated tomato and saffron infusion'
      },

      content: {
        eyebrow: '',
        kicker: 'Building the flavour',
        title: 'Add the grated tomato & saffron',
        text:
          'Infuse the saffron in hot water before adding it to the mix.',
        note:
          'Stir gently and bring all the ingredients together, spreading them across the pan.'
      },

      timer: false
    },

    /* =====================================================
       PREPARE FOR THE RICE
    ===================================================== */

    {
      type: 'step',

      chapter: 'Prepare for the rice',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/addding_water_with_jar_desktop.webp?v=1786707987',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/adding_water_with_jar_mobile.webp?v=1786707987',

        alt:
          'Add the first portion of water'
      },

      content: {
        eyebrow: '',
        kicker: 'Prepare for the rice',
        title: 'The rice is the key',
        text:
          'At the end, the rice should be perfectly cooked, loose and with no liquid remaining.',
        note:
          'Let’s add the water.'
      },

      timer: false
    },

    {
      type: 'step',

      chapter: 'Prepare for the rice',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/take_the_water_measure_toothpick_mobile.webp?v=1786706674',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/tale_the_measure_tothpick_mobile.webp?v=1786706675',

        alt:
          'Measure the water level with a toothpick'
      },

      content: {
        eyebrow: '',
        kicker: 'Prepare for the rice',
        title: 'Take the measure',
        text:
          'Add 60% of the water and use a toothpick to measure the water level.',
        note:
          'TIP: Keep the toothpick with the water-level mark for later.'
      },

      timer: false
    },

    {
      type: 'step',

      chapter: 'Prepare for the rice',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/add_remainig_water_desktop.webp?v=1786717069',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/add_remainig_watter_mobile.webp?v=1786717069',

        alt:
          'Add the remaining water'
      },

      content: {
        eyebrow: '',
        kicker: 'Prepare for the rice',
        title: 'Add the remaining 40% of the water',
        text: '',
        note: ''
      },

      timer: false
    },

    {
      type: 'step',

      chapter: 'Prepare for the rice',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/boil_and_simerdesk_top.webp?v=1786717069',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/boil_nad_simmer_mobile.webp?v=1786717069',

        alt:
          'Boil and simmer the paella broth'
      },

      content: {
        eyebrow: '',
        kicker: 'Prepare for the rice',
        title: 'Boil and simmer, manage your gas flames',
        text:
          'Bring to a rapid boil for about 10 minutes, then lower to a simmer for another 15–20 minutes.',
        note:
          'The water level should be back to the mark on your toothpick. If it is higher, keep cooking; if it is lower, add a little more water.'
      },

      timer: 'Approx. 30 min'
    },

    /* =====================================================
       GET THE FLAVOUR INTO THE RICE
    ===================================================== */

    {
      type: 'step',

      chapter: 'Get the flavour into the rice',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/add_rice_desktop.webp?v=1786717069',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/add_the_rice_mobile.webp?v=1786717069',

        alt:
          'Add the Bomba rice'
      },

      content: {
        eyebrow: '',
        kicker: 'Get the flavour into the rice',
        title: 'Gently pour the Bomba rice evenly into the pan',
        text:
          'Simmer for 10 minutes, then reduce the heat and gently simmer until the broth is gone, about another 8–10 minutes.',
        note:
          'The rice should be submerged in the liquid and evenly distributed. Do not stir.'
      },

      timer: 'Approx. 20 min'
    },

    /* =====================================================
       FINAL TOUCH
    ===================================================== */

    {
      type: 'step',

      chapter: 'The final touch',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/paella_ready_desktop.webp?v=1786730539',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/paella_ready_mobile.webp?v=1786730539',

        alt:
          'Finished Paella Valenciana'
      },

      content: {
        eyebrow: '',
        kicker: 'The job is done',
        title: 'Your paella is done',
        text:
          'The water has evaporated. Now you can go for the socarrat.',
        note:
          'Socarrat is the crispy, caramelised and toasted layer of rice that forms at the bottom of the paella pan during cooking.'
      },

      timer: false
    },

    {
      type: 'step',

      chapter: 'The final touch',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/socarrat_desk_top.webp?v=1786730270',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/socarrat_mobile.webp?v=1786730269',

        alt:
          'The socarrat at the bottom of the paella'
      },

      content: {
        eyebrow: '',
        kicker: '',
        title: 'The socarrat',
        text:
          'Turn up the heat for about 30 seconds to encourage the socarrat to form. Stop immediately if you start to smell burning.',
        note:
          'At the end of the cooking time, you should hear a faint ticking or crackling from the bottom layer of rice. This means the rice is caramelising underneath and forming the socarrat.'
      },

      timer: '30 sec'
    },

    /* =====================================================
       ENJOY
    ===================================================== */

    {
      type: 'step',

      chapter: 'Enjoy the moment',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/king_of_the_party_desktop.webp?v=1786730269',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/king_of_the_party_mobile.webp?v=1786730270',

        alt:
          'Serving Paella Valenciana to friends'
      },

      content: {
        eyebrow: '',
        kicker: 'Enjoy the moment',
        title: 'You are now the soul of the party',
        text:
          'Allow the paella to rest for 5 minutes, then start serving.',
        note: ''
      },

      timer: false
    }

  ]

};
/* =========================================================
   FINAL EXIT — PAELLA SET GUIDE
========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  const exitConfig = {
    visible: true,

    kicker: 'Continue exploring',

    title: 'Choose your Paella Set Configuration',

    text: 'Find the right pan, burner and setup for your table.',

    url: '/pages/paella-set-guide',

   image:
  'https://cdn.shopify.com/s/files/1/0784/2065/files/paella_configuration.png?v=1785432720',

    alt:
      'Choose your Paella Set Configuration'
  };

  if (!exitConfig.visible) {
    return;
  }

  const guide =
    document.getElementById('spanish-kitchen-guide');

  if (!guide) {
    return;
  }

  const exit =
    document.createElement('section');

  exit.className =
    'paella-guide-exit';

  exit.innerHTML = `

    <a
      class="paella-guide-exit__link"
      href="${exitConfig.url}"
      aria-label="${exitConfig.title}"
    >

      <img
        class="paella-guide-exit__image"
        src="${exitConfig.image}"
        alt="${exitConfig.alt}"
        loading="lazy"
      >

      <div class="paella-guide-exit__overlay"></div>

      <div class="paella-guide-exit__content">

        <div class="paella-guide-exit__kicker">
          ${exitConfig.kicker}
        </div>

        <h2 class="paella-guide-exit__title">
          ${exitConfig.title}
        </h2>

        <p class="paella-guide-exit__text">
          ${exitConfig.text}
        </p>

      </div>

    </a>

  `;

  guide.appendChild(exit);


  /* =======================================================
     STYLES
  ======================================================= */

  const style =
    document.createElement('style');

  style.textContent = `

    .paella-guide-exit {
      width: 85%;
      max-width: 1500px;
      margin: 48px auto 70px;
    }

    .paella-guide-exit__link {
      position: relative;
      display: block;
      width: 100%;
      overflow: hidden;
      border-radius: 22px;
      text-decoration: none;
      background: #0b2f47;
    }

    .paella-guide-exit__image {
      display: block;
      width: 100%;
      height: clamp(340px, 42vw, 600px);
      object-fit: cover;
      transition:
        transform 0.7s ease,
        filter 0.7s ease;
    }

    .paella-guide-exit__overlay {
      position: absolute;
      inset: 0;

      background:
        linear-gradient(
          90deg,
          rgba(5, 22, 34, 0.72) 0%,
          rgba(5, 22, 34, 0.46) 38%,
          rgba(5, 22, 34, 0.08) 72%,
          rgba(5, 22, 34, 0.02) 100%
        );

      pointer-events: none;
    }

    .paella-guide-exit__content {
      position: absolute;
      left: clamp(28px, 5vw, 76px);
      bottom: clamp(30px, 6vw, 76px);

      width: min(560px, 72%);

      color: #ffffff;
      z-index: 2;
    }

    .paella-guide-exit__kicker {
      margin-bottom: 12px;

      font-family:
        Arial,
        Helvetica,
        sans-serif;

      font-size: 12px;
      line-height: 1.2;

      font-weight: 700;

      letter-spacing: 0.14em;
      text-transform: uppercase;

      opacity: 0.88;
    }

    .paella-guide-exit__title {
      margin: 0;

      color: #ffffff;

      font-family:
        Georgia,
        'Times New Roman',
        serif;

      font-size:
        clamp(30px, 4vw, 58px);

      line-height: 1.03;

      font-weight: 400;
    }

    .paella-guide-exit__text {
      max-width: 480px;

      margin:
        18px 0 0;

      color: #ffffff;

      font-family:
        Arial,
        Helvetica,
        sans-serif;

      font-size:
        clamp(15px, 1.25vw, 18px);

      line-height: 1.5;

      opacity: 0.92;
    }

    .paella-guide-exit__link:hover
    .paella-guide-exit__image {
      transform: scale(1.025);
      filter: brightness(0.96);
    }


    @media (max-width: 749px) {

      .paella-guide-exit {
        width: 85%;
        margin:
          32px auto
          48px;
      }

      .paella-guide-exit__link {
        border-radius: 18px;
      }

      .paella-guide-exit__image {
        height: 520px;
      }

      .paella-guide-exit__overlay {
        background:
          linear-gradient(
            0deg,
            rgba(5, 22, 34, 0.78) 0%,
            rgba(5, 22, 34, 0.40) 48%,
            rgba(5, 22, 34, 0.06) 80%
          );
      }

      .paella-guide-exit__content {
        left: 24px;
        right: 24px;
        bottom: 28px;

        width: auto;
      }

      .paella-guide-exit__title {
        font-size:
          clamp(30px, 9vw, 42px);
      }

      .paella-guide-exit__text {
        font-size: 15px;
      }

    }

  `;

  document.head.appendChild(style);

});
/* =========================================================
   PAELLA EDITORIAL STORY
   Shopify Page Content → Before Shop the Ingredients
========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  const editorial =
    document.getElementById('paella-editorial-story');

  const shop =
    document.querySelector('.skgc-ingredients');

  if (!editorial || !shop) {
    return;
  }


  /* =======================================================
     MOVE INTO THE COOKING GUIDE
  ======================================================= */

  editorial.style.display = '';

  editorial.classList.add(
    'paella-editorial'
  );

  shop.parentNode.insertBefore(
    editorial,
    shop
  );


  /* =======================================================
     READ MORE / SHOW LESS
  ======================================================= */

  const fullText =
    editorial.querySelector(
      '.paella-editorial-full'
    );

  const toggle =
    editorial.querySelector(
      '.paella-editorial-toggle'
    );

  const moreLabel =
    editorial.querySelector(
      '.paella-editorial-toggle__more'
    );

  const lessLabel =
    editorial.querySelector(
      '.paella-editorial-toggle__less'
    );

  const symbol =
    editorial.querySelector(
      '.paella-editorial-toggle__symbol'
    );


  if (
    fullText &&
    toggle
  ) {

    toggle.addEventListener(
      'click',
      function () {

        const isOpen =
          toggle.getAttribute(
            'aria-expanded'
          ) === 'true';


        toggle.setAttribute(
          'aria-expanded',
          String(!isOpen)
        );


        fullText.hidden =
          isOpen;


        if (moreLabel) {
          moreLabel.hidden =
            !isOpen;
        }


        if (lessLabel) {
          lessLabel.hidden =
            isOpen;
        }


        if (symbol) {
          symbol.textContent =
            isOpen
              ? '+'
              : '−';
        }

      }
    );
  }


  /* =======================================================
     EDITORIAL STYLES
     Local to this Paella Guide
  ======================================================= */

  const style =
    document.createElement('style');


  style.textContent = `

    /* -----------------------------------------------------
       EDITORIAL CONTAINER
    ----------------------------------------------------- */

    .paella-editorial {
      width: 85%;
      max-width: 1200px;

      margin:
        70px auto
        72px;

      padding:
        0;

      color: #0b2f47;
    }


    /* -----------------------------------------------------
       EYEBROW
    ----------------------------------------------------- */

    .paella-editorial-eyebrow {
      margin-bottom: 14px;

      font-family:
        Arial,
        Helvetica,
        sans-serif;

      font-size: 12px;
      line-height: 1.2;

      font-weight: 700;

      letter-spacing: 0.14em;
      text-transform: uppercase;

      color: #972735;
    }


    /* -----------------------------------------------------
       MAIN TITLE
    ----------------------------------------------------- */

    .paella-editorial h2 {
      max-width: 900px;

      margin:
        0 0 24px;

      font-family:
        Georgia,
        'Times New Roman',
        serif;

      font-size:
        clamp(32px, 4vw, 54px);

      line-height: 1.08;

      font-weight: 400;

      color: #0b2f47;
    }


    /* -----------------------------------------------------
       BODY
    ----------------------------------------------------- */

    .paella-editorial p {
      max-width: 820px;

      margin:
        0 0 18px;

      font-family:
        Arial,
        Helvetica,
        sans-serif;

      font-size:
        17px;

      line-height: 1.7;

      color: #263d49;
    }


    .paella-editorial-summary p:first-of-type {
      font-size: 19px;
      line-height: 1.65;
    }


    /* -----------------------------------------------------
       EXPANDED CONTENT
    ----------------------------------------------------- */

    .paella-editorial-full {
      margin-top: 28px;
    }


    .paella-editorial-full[hidden] {
      display: none !important;
    }


    .paella-editorial h3 {
      max-width: 820px;

      margin:
        42px 0
        20px;

      font-family:
        Georgia,
        'Times New Roman',
        serif;

      font-size:
        clamp(25px, 2.7vw, 36px);

      line-height: 1.15;

      font-weight: 400;

      color: #0b2f47;
    }


    /* -----------------------------------------------------
       QUOTES
    ----------------------------------------------------- */

    .paella-editorial blockquote {
      max-width: 820px;

      margin:
        32px 0;

      padding:
        4px 0
        4px 24px;

      border-left:
        3px solid #b96447;

      font-family:
        Georgia,
        'Times New Roman',
        serif;

      font-size:
        clamp(20px, 2vw, 27px);

      line-height: 1.45;

      font-style: italic;

      color: #0b2f47;
    }


    /* -----------------------------------------------------
       READ MORE
    ----------------------------------------------------- */

    .paella-editorial-toggle {
      display: inline-flex;

      align-items: center;
      gap: 12px;

      margin-top: 12px;

      padding:
        0 0
        7px;

      border: 0;
      border-bottom:
        1px solid currentColor;

      background: transparent;

      font-family:
        Arial,
        Helvetica,
        sans-serif;

      font-size: 13px;
      line-height: 1.2;

      font-weight: 700;

      letter-spacing: 0.08em;
      text-transform: uppercase;

      color: #0b2f47;

      cursor: pointer;
    }


    .paella-editorial-toggle__symbol {
      display: inline-flex;

      align-items: center;
      justify-content: center;

      width: 20px;
      height: 20px;

      font-size: 20px;
      line-height: 1;

      font-weight: 400;
    }


    /* -----------------------------------------------------
       MOBILE
    ----------------------------------------------------- */

    @media (max-width: 749px) {

      .paella-editorial {
        width: 85%;

        margin:
          48px auto
          52px;
      }


      .paella-editorial-eyebrow {
        margin-bottom: 12px;

        font-size: 11px;
      }


      .paella-editorial h2 {
        margin-bottom: 20px;

        font-size:
          clamp(30px, 9vw, 40px);

        line-height: 1.08;
      }


      .paella-editorial p {
        font-size: 15.5px;

        line-height: 1.65;

        margin-bottom: 16px;
      }


      .paella-editorial-summary p:first-of-type {
        font-size: 17px;
      }


      .paella-editorial-full {
        margin-top: 24px;
      }


      .paella-editorial h3 {
        margin:
          34px 0
          17px;

        font-size:
          26px;
      }


      .paella-editorial blockquote {
        margin:
          28px 0;

        padding-left: 18px;

        font-size: 20px;
      }


      .paella-editorial-toggle {
        margin-top: 8px;

        font-size: 12px;
      }

    }

  `;


  document.head.appendChild(
    style
  );

});

/* =========================================================
   MOBILE SLIDE TEXT OVERRIDES
   Valencian Paella
========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  function applyMobileSlideOverrides() {

    const isMobile =
      window.matchMedia(
        '(max-width: 900px)'
      ).matches;

    const riceTitle =
      document.querySelector(
        '.skgc__slide[data-index="15"] .skgc__title'
      );

    if (!riceTitle) {
      return;
    }

    if (
      !riceTitle.dataset.desktopTitle
    ) {
      riceTitle.dataset.desktopTitle =
        riceTitle.textContent.trim();
    }

    riceTitle.textContent =
      isMobile
        ? 'Add the Rice'
        : riceTitle.dataset.desktopTitle;
  }


  applyMobileSlideOverrides();


  window.addEventListener(
    'resize',
    applyMobileSlideOverrides
  );

});